import { lazyLoad } from "unlazy";

images = JSON.parse(document.getElementById("homepage-images").textContent);

var randomImage = images[Math.floor(Math.random() * images.length)];

// var randomImage = {
//   file: "canadawater.jpg",
//   location:
//     "Mijinemungshing Lake, Lake Superior Provincial Park, Ontario, Canada",
//   date: "2018-08-15",
//   width: 5472,
//   height: 3648,
// };

console.log(randomImage);

if (randomImage["location"] === "") {
  document.querySelector("#homepage-caption").classList.add("hidden");
} else {
  document.querySelector("#homepage-caption-name").textContent =
    randomImage["location"];
  document.querySelector("#homepage-caption-date").textContent =
    `(${new Date(randomImage["date"]).toLocaleDateString("en-US", { year: "numeric", month: "long" })})`;
}

thumbhash = JSON.parse(document.getElementById("thumbhashes").textContent)[
  randomImage["file"]
];

const url = `images/backgrounds/${randomImage["file"]}`;

async function placeImage() {
  const el = document.querySelector("#homepage-img");
  el.width = randomImage["width"];
  el.height = randomImage["height"];
  el.setAttribute(
    "style",
    `aspect-ratio: ${randomImage["width"]}/${randomImage["height"]};`,
  );
  el.dataset.src = url;
  el.dataset.thumbhash = thumbhash;
  lazyLoad(el, {
    onImageLoad: (image) => {
      document.querySelector("#homepage-caption").classList.remove("opacity-0");
    },
  });
}

placeImage();
